import BreadCrumb from '../components/Breadcrumb/index.vue';
export default {
  install: function install(Vue) {
    Vue.component('BreadCrumb', BreadCrumb);
  }
};